import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
function WorkSpaceIcon(_ref) {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 28",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21.333 3.333H15.76C15.2 1.787 13.733.667 12 .667c-1.733 0-3.2 1.12-3.76 2.666H2.667A2.675 2.675 0 000 6v18.667c0 1.466 1.2 2.666 2.667 2.666h18.666c1.467 0 2.667-1.2 2.667-2.666V6c0-1.467-1.2-2.667-2.667-2.667zm-9.333 0c.733 0 1.333.6 1.333 1.334C13.333 5.4 12.733 6 12 6s-1.333-.6-1.333-1.333c0-.734.6-1.334 1.333-1.334zM14.667 22H5.333v-2.667h9.334V22zm4-5.333H5.333V14h13.334v2.667zm0-5.334H5.333V8.667h13.334v2.666z",
    fill: color
  }));
}
export default /*#__PURE__*/memo(WorkSpaceIcon);